import { postMessage } from '../services/reactNativeWrapper';

export function downloadFileToRnWrapper(
  url: string,
  filename: string,
  key: string
) {
  return fetch(url)
    .then((res) => res.arrayBuffer())
    .then((buffer) => {
      const blob = new Blob([buffer], {
        type: 'application/octet-stream',
      });
      const reader = new FileReader();
      const handleRead = () => {
        postMessage(reader.result as string, {
          key,
          filename,
        });
        reader.removeEventListener('load', handleRead, false);
      };
      reader.addEventListener('load', handleRead, false);
      reader.readAsDataURL(blob);
    });
}
